'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var dimensionsInit = exports.dimensionsInit = undefined;

exports.dimensionsInit = dimensionsInit = function dimensionsInit(c) {
    var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var t = this,
        appManager = c.appManager,
        requestManager = c.requestManager,
        dimensionConfig = c.dimensionConfig,
        apiPath = appManager.getApiPath(),
        displayPropertyUrl = appManager.getDisplayPropertyUrl();

    return {
        baseUrl: apiPath + '/dimensions.json',
        params: ['fields=id,' + displayPropertyUrl + ',dimensionType', 'paging=false'].concat(extraParams),
        success: function success(r) {
            appManager.addDimensions(r.dimensions);
            dimensionConfig.add(r.dimensions);

            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=dimensionsInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/dimensionsInit.js
 ** module id = 121
 ** module chunks = 0 1
 **/